import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import { Button, Box, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useDispatch, useSelector } from "react-redux";
import { setCSVBatchData } from "../../redux/slices/contentSlice/contentForm/contentForm";
import OneDrivePicker from "./OneDrivePicker2";
import { urlToFile } from "../../helper/onedrive/urlToFile";
import useCategorizeFiles from "../../hooks/useCategorizeFiles";
import ViewCSVData from "./ViewCSVData";
import useHandleFilePath from "../../hooks/useHandleFilePath";
import ThumbnailMapper from "./ThumbnailMapper";
import { setSelectedItems } from "../../redux/slices/contentSlice/contentForm/contentForm";

const BatchFileSelector = ({ mediaType }) => {
  const [files, setFiles] = useState([]);
  const onedriveFiles = useSelector((state) => state.oneDriveContent.files);
  const { videos, images, pdfs, csv, audios } = useCategorizeFiles(
    onedriveFiles.length ? onedriveFiles : files,
    onedriveFiles.length ? "onedrive" : "local"
  );
  const dispatch = useDispatch();
  const { handleFilePath } = useHandleFilePath();
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
  };

  const handleFilePaths = (files) => {
    const episodesFilePaths = files.map((file, index) => {
      if (
        (mediaType === "audios" && index < audios.length) ||
        (mediaType === "videos" && index < videos.length) ||
        (mediaType === "pdfs" && index < pdfs.length)
      ) {
        const title = csv[index]?.Title;

        const { fileType, filePath } = handleFilePath(file, title);
        return filePath;
      } else {
        return;
      }
    });
    return episodesFilePaths;
  };
  const handleDisableButton = () => {
    return false; 
  };

  const processFiles = (specificTypeOfFiles) => {
    const filePaths = handleFilePaths(specificTypeOfFiles);
    console.log(filePaths, "filePaths");
    const thumbnailsFilePaths = handleFilePaths(images);

    filePaths.forEach((filePath, index) => {
      dispatch(
        setSelectedItems({
          filePath: filePath,
          masterFile:
            specificTypeOfFiles[index]?.downloadUrl ||
            URL.createObjectURL(specificTypeOfFiles[index]),
          posterFilePath:
            thumbnailsFilePaths[
              index < thumbnailsFilePaths.length ? index : index - 1
            ],
          posterFile:
            images[
              index < thumbnailsFilePaths.length
                ? index
                : thumbnailsFilePaths.length - 1
            ]?.downloadUrl ||
            URL.createObjectURL(
              images[
                index < thumbnailsFilePaths.length
                  ? index
                  : thumbnailsFilePaths.length - 1
              ]
            ),
          typeOfFile: onedriveFiles.length ? "onedrive" : "local",
        })
      );
    });
  };

  const handleSave = () => {
    if (mediaType === "audios") {
      // const filePaths = handleFilePaths(audios);
      // console.log(filePaths, "filePaths");
      // const thumbnailsFilePaths = handleFilePaths(images);
      // filePaths.forEach((filePath, index) => {
      //   dispatch(
      //     setSelectedItems({
      //       filePath: filePath,
      //       masterFile:
      //         audios[index]?.downloadUrl || URL.createObjectURL(audios[index]),
      //       posterFilePath:
      //         thumbnailsFilePaths[
      //           index < thumbnailsFilePaths.length ? index : index - 1
      //         ],
      //       posterFile:
      //         images[
      //           index < thumbnailsFilePaths.length
      //             ? index
      //             : thumbnailsFilePaths.length - 1
      //         ]?.downloadUrl ||
      //         URL.createObjectURL(
      //           images[
      //             index < thumbnailsFilePaths.length
      //               ? index
      //               : thumbnailsFilePaths.length - 1
      //           ]
      //         ),
      //       typeOfFile: onedriveFiles.length ? "onedrive" : "local",
      //     })
      //   );
      // });

      processFiles(audios);
    }
    if (mediaType === "pdfs") {
      const filePaths = handleFilePaths(pdfs);
      console.log(filePaths, "filePaths");
      const thumbnailsFilePaths = handleFilePaths(images);
      filePaths.forEach((filePath, index) => {
        dispatch(
          setSelectedItems({
            filePath: filePath,
            masterFile:
              pdfs[index]?.downloadUrl || URL.createObjectURL(pdfs[index]),
            posterFilePath:
              thumbnailsFilePaths[
                index < thumbnailsFilePaths.length ? index : index - 1
              ],
            posterFile:
              images[
                index < thumbnailsFilePaths.length
                  ? index
                  : thumbnailsFilePaths.length - 1
              ]?.downloadUrl ||
              URL.createObjectURL(
                images[
                  index < thumbnailsFilePaths.length
                    ? index
                    : thumbnailsFilePaths.length - 1
                ]
              ),
            typeOfFile: onedriveFiles.length ? "onedrive" : "local",
          })
        );
      });
    }
    if (mediaType === "videos") {
      processFiles(videos);
    }
  };

  return (
    <Box>
      <Box display={"flex"} gap={4}>
        <Button
          component="label"
          variant="outlined"
          fullWidth
          startIcon={<UploadFileIcon />}
        >
          Batch Upload
          <input hidden type="file" onChange={handleFileChange} multiple />
        </Button>
        <Box width={"100%"}>
          <OneDrivePicker handleDisableButton={handleDisableButton}/>
        </Box>
      </Box>

      {csv && (
        <Box mt={2}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h6">All Files</Typography>
            <Typography variant="body1">
              No of {mediaType}:{" "}
              {mediaType === "audios"
                ? audios.length
                : mediaType === "videos"
                ? videos.length
                : mediaType === "pdfs"
                ? pdfs.length
                : null}
            </Typography>
            <ViewCSVData csvData={csv} />
          </Box>
          {mediaType === "audios" ? (
            <Box>
              {audios.map((audio) => (
                <Box>
                  <Typography my={2}>{audio.name}</Typography>
                  <audio
                    controls
                    src={audio?.getUrl || URL.createObjectURL(audio)}
                  />
                </Box>
              ))}
              <ThumbnailMapper files={audios} thumbnails={images} />
            </Box>
          ) : mediaType === "videos" ? (
            <>
              {videos.map((video) => (
                <>
                  <Typography my={2}>{video.name}</Typography>
                </>
              ))}
              <ThumbnailMapper files={videos} thumbnails={images} />
            </>
          ) : mediaType === "pdfs" ? (
            <>
              {pdfs.map((video) => (
                <>
                  <Typography my={2}>{video.name}</Typography>
                </>
              ))}
              <ThumbnailMapper files={pdfs} thumbnails={images} />
            </>
          ) : null}
          <Box display={"flex"} justifyContent={"space-between"}>
            <Button onClick={handleSave} variant="outlined">
              Clear
            </Button>
            <Button onClick={handleSave} variant="contained">
              Save Changes
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default BatchFileSelector;
